export default "__VITE_ASSET__BPMop7iP__"